import Calendar from "react-calendar";
import "./calendar.css";

export default Calendar;
